import { Alert } from '@sr/ui-library';
import { resolveRoyaltiesHistoricalBanner } from '../constant/royaltiesHistoricalBanner';
import { reduxServices } from '../reducers/reduxServices';
import { useTypedSelector } from '../stateStore';
import type { RoyaltiesMsr3RegionLayoutConfig } from './royaltiesLayoutConfig';
import { RoyaltiesSectionTabsLayout } from './RoyaltiesSectionTabsLayout';

/**
 * Shared MSR3 shell for Royalties ANZ / World: page header, historical
 * cut-off banner, segmented tabs (agents only), and outlet for tab content.
 *
 * The banner reads the region's *own* Parameter Store keys
 * (`historicalBannerConfigKeys`), so Member Services can word ANZ and
 * World separately without a frontend deploy.
 */
export const RoyaltiesMsr3RegionLayout = ({
  historicalBannerConfigKeys,
  ...config
}: RoyaltiesMsr3RegionLayoutConfig) => {
  const configuration = useTypedSelector(
    reduxServices.setting.selectors.configuration,
  );
  const historicalBanner = resolveRoyaltiesHistoricalBanner(
    configuration,
    historicalBannerConfigKeys,
  );

  return (
    <RoyaltiesSectionTabsLayout
      {...config}
      aboveOutlet={
        <Alert title={historicalBanner.title} variant="info">
          <p className="text-sm">{historicalBanner.body}</p>
        </Alert>
      }
    />
  );
};
